import Container from '@/components/ui/Container';
import SectionHeader from '@/components/ui/SectionHeader';
import CourseCard from './CourseCard';
import { courses } from '@/constants/courses';

const CourseOverview = () => {
  // Calculate summary statistics
  const totalCourses = courses.length;

  const formattedDuration = "+66h";

  return (
    <section id="wszystkie-kursy" className="py-24 bg-gray-50">
      <Container className="px-4 sm:px-6 lg:px-8">
        <SectionHeader
          title="Przegląd kursów"
          description="Poznaj nasze kompleksowe programy szkoleniowe"
          className="mb-12"
        />
        <div className="max-w-3xl mx-auto space-y-4">
          {courses.map((course, index) => (
            <CourseCard
              key={index}
              {...course}
              index={index}
              delay={index * 0.1}
            />
          ))}
        </div>
        
        <div className="max-w-3xl mx-auto mt-12">
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm">
            <h3 className="text-2xl font-bold text-dark mb-6 text-center">Podsumowanie pakietu</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <p className="text-3xl sm:text-4xl font-bold text-primary mb-2">{totalCourses}</p>
                <p className="text-sm sm:text-base text-gray-600">Kursów</p>
              </div>
              <div className="text-center">
                <p className="text-3xl sm:text-4xl font-bold text-primary mb-2">{formattedDuration}</p>
                <p className="text-sm sm:text-base text-gray-600">Godzin materiałów</p>
              </div>
              <div className="text-center">
                <p className="text-3xl sm:text-4xl font-bold text-primary mb-2">1500+</p>
                <p className="text-sm sm:text-base text-gray-600">Zadowolonych Właścicieli Szkół</p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CourseOverview;